import { render, staticRenderFns } from "./LayoutBrain.vue?vue&type=template&id=534b2743"
import script from "./LayoutBrain.vue?vue&type=script&lang=js"
export * from "./LayoutBrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports